import { useCallback, useEffect, useState } from 'react';
import dateformat from 'dateformat';
import { useSelector } from 'react-redux';


const MeetingTalk = ({ meeting, meetingUser, storeMutate, readOnly = false }) => {
    const auth = useSelector((state) => state.auth);
    const [answer1, setAnswer1] = useState("");
    const [answer2, setAnswer2] = useState("");
    const [answer3, setAnswer3] = useState("");
    const [question, setQuestion] = useState("");

    useEffect(() => {
        if (meetingUser === null) return;
        if (meetingUser.answer1 !== null) setAnswer1(meetingUser.answer1);
        if (meetingUser.answer2 !== null) setAnswer2(meetingUser.answer2);
        if (meetingUser.answer3 !== null) setAnswer3(meetingUser.answer3);
        if (meetingUser.question !== null) setQuestion(meetingUser.question);
    }, [meetingUser]);

    useEffect(() => {
        const autoSizeElementList = document.querySelectorAll(".autosize");
        autoSizeElementList.forEach(element => {
            element.style.height = "auto";
            element.style.height = element.scrollHeight + "px";
        });
    }, [answer1, answer2, answer3, question]);


    const onSave = useCallback((type) => {
        if (!auth.authenticated) return;
        if (storeMutate.isPending) return;
        if (!window.confirm('전송 하시겠습니까?')) {
            return;
        }

        let tempData = {
            meeting_id: meeting.id,
            content: '',
            type: type
        }


        switch (type) {
            case 'answer1':
                tempData.content = answer1;
                break;
            case 'answer2':
                tempData.content = answer2;
                break;
            case 'answer3':
                tempData.content = answer3;
                break;
            case 'question':
                tempData.content = question;
                break;
            default:
                return;
        }
        storeMutate.mutate(tempData);
    }, [answer1, answer2, answer3, question, auth, meeting, storeMutate]);

    if (meeting === null) return null;


    let meetingQuestion = null;

    if (meeting.expire && (meetingUser === null || meetingUser.state === 'answer' || meetingUser.state === 'question')) {
        meetingQuestion = (
            <div>
                <h3><span className="talk_icon">친구들</span><span className="arrow_icon">독서길라잡이</span></h3>
                <div className="talk_box box2">
                    <p className="no_data">
                        독서길라잡이의 답변 기간은 {dateformat(meeting.stdate.substring(0, 20), 'yyyy.mm.dd.')} 부터 {dateformat(meeting.eddate.substring(0, 20), 'yyyy.mm.dd.')} 까지 입니다.
                    </p>
                </div>
            </div>
        );
    } else if (meetingUser === null) {
        meetingQuestion = (
            <div>
                <h3><span className="talk_icon">친구들</span><span className="arrow_icon">독서길라잡이</span></h3>
                <div className="talk_box box2">
                    <div className="child clear">
                        <span className="name"></span>
                        <span className="date"></span>
                        <div className="text">질문을 작성해보세요.</div>
                    </div>
                    <div className="writer clear">
                        <span className="name">독서길라잡이</span>
                        <span className="date"></span>
                        <div className="text">친구들이 질문을 작성하면 독서길라잡이의 생각을 알려주실 거에요.</div>
                    </div>
                </div>
            </div>
        );
    } else {
        meetingQuestion = (
            <div>
                <div className="talk_bookgomi"></div>
                <div className="talk_box box2">
                    <div className="child clear">
                        <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                            <span className="name">{auth.name}</span>
                        </div>
                        <span className="date">{meeting.meetingUser !== null && meetingUser.questionTime !== null && dateformat(meetingUser.questionTime, 'yyyy년 mm월 dd일')}</span>
                        {(meetingUser.state === 'question') && !meeting.expire && <button type="button" className="btn _border" onClick={() => onSave('question')}>전송</button>}
                        {(meetingUser.state === 'question') && !meeting.expire &&
                            <div className="text"><textarea name="question" className="autosize" placeholder="질문을 작성해보세요." onChange={(e) => setQuestion(e.target.value)} value={question}></textarea></div>
                        }
                        {((meetingUser.state !== 'question') || meeting.expire) && <div className="text">&nbsp;{question}</div>}
                    </div>
                    {meetingUser.state === 'question' &&
                        <div className="questionAlert">
                            전송을 누르면 더이상 수정이 안됩니다. <br />
                            신중하게 해주세요
                        </div>
                    }

                    <div className="writer clear">
                        <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                            <span className="name">독서길라잡이</span>
                        </div>
                        <span className="date">{meetingUser !== null && meetingUser.questionAnswerTime !== null && dateformat(meetingUser.questionAnswerTime, 'yyyy년 mm월 dd일')}</span>
                        <div className="text">{(meetingUser !== null && meetingUser.authorAnswer !== '' && meetingUser.authorAnswer !== null) ? meetingUser.authorAnswer : '친구들이 질문을 작성하면 독서길라잡이의 생각을 알려주실 거에요.'}</div>
                    </div>
                </div>
            </div>
        );
    }

    //로그인 안하면 여기 못오지 않나?
    if (meeting === null) return null;
    // 로그인 안했을때 보여주는
    if (meetingUser === null) {
        return (
            <div className="section talk_area">
                <div className="inner">
                    <h3><span className="talk_icon">독서길라잡이</span><span className="arrow_icon">친구들</span></h3>
                    <div className="talk_box box1">
                        <div className="writer clear">
                            <span className="name">독서길라잡이</span>
                            <span className="date">{dateformat(meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meeting.question1}</div>
                        </div>
                        <div className="child clear">
                            <span className="name"></span>
                            <span className="date"></span>
                            <div className="text">친구들의 생각을 적어보세요.</div>
                        </div>
                        <div className="writer clear">
                            <span className="name">독서길라잡이</span>
                            <span className="date">{dateformat(meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meeting.question2}</div>
                        </div>
                        <div className="child clear">
                            <span className="name"></span>
                            <span className="date"></span>
                            <div className="text">친구들의 생각을 적어보세요.</div>
                        </div>
                        {meeting.question3 !== null && meeting.question3 !== '' &&
                            <>
                                <div className="writer clear">
                                    <span className="name">독서길라잡이</span>
                                    <span className="date">{dateformat(meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                                    <div className="text">{meeting.question3}</div>
                                </div>
                                <div className="child clear">
                                    <span className="name"></span>
                                    <span className="date"></span>
                                    <div className="text">친구들의 생각을 적어보세요.</div>
                                </div>
                            </>
                        }
                    </div>

                </div>
            </div>
        )
    }

    return (
        <div className="section talk_area">
            <div className="inner">
                <div className="talk_bookgomi"></div>
                <div className="talk_box box1">
                    {meetingUser.coverComment !== '' && meetingUser.coverComment !== null && meetingUser.coverComment !== undefined &&
                        <div className="child clear">
                            <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                                <span className="name">{auth.name}</span>
                            </div>
                            <span className="date">표지 상상하기</span>
                            <div className="text">{meetingUser.coverComment}</div>
                        </div>
                    }

                    <div className="writer clear">
                        <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                            <span className="name">독서길라잡이</span>
                        </div>
                        <span className="date">{dateformat(meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                        <div className="text">{meeting.question1}</div>
                    </div>
                    <div className="child clear">
                        <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                            <span className="name">{auth.name}</span>
                        </div>
                        <span className="date">{meetingUser.answer1Time !== null && dateformat(meetingUser.answer1Time, 'yyyy년 mm월 dd일')}</span>
                        {meetingUser.state !== 'author_request' && meetingUser.state !== 'author_answer' &&
                            <button type="button" className="btn _border" onClick={() => onSave('answer1')}>전송</button>
                        }
                        {meetingUser.state !== 'author_request' && meetingUser.state !== 'author_answer' &&
                            <div className="text"><textarea name="answer1" className="autosize" placeholder="친구들의 생각을 적어보세요." onChange={e => setAnswer1(e.target.value)} value={answer1} /></div>
                        }
                        {(meetingUser.state === 'author_request' || meetingUser.state === 'author_answer') && <div className="text">{answer1}</div>}
                    </div>

                    {meetingUser.answerReply1 !== null && meetingUser.answerReply1 !== '' &&
                        <div className="writer clear">
                            <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                <span className="name">독서길라잡이</span>
                            </div>
                            <span className="date">{dateformat(meetingUser.answerReply1Time, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meetingUser.answerReply1}</div>
                        </div>
                    }

                    <div className="writer clear">
                        <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                            <span className="name">독서길라잡이</span>
                        </div>
                        <span className="date">{dateformat(meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                        <div className="text">{meeting.question2}</div>
                    </div>
                    <div className="child clear">
                        <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                            <span className="name">{auth.name}</span>
                        </div>
                        <span className="date">{meetingUser.answer2Time !== null && dateformat(meetingUser.answer2Time, 'yyyy년 mm월 dd일')}</span>
                        {meetingUser.state !== 'author_request' && meetingUser.state !== 'author_answer' &&
                            <button type="button" className="btn _border" onClick={() => onSave('answer2')}>전송</button>
                        }
                        {meetingUser.state !== 'author_request' && meetingUser.state !== 'author_answer' &&
                            <div className="text"><textarea name="answer2" className="autosize" placeholder="친구들의 생각을 적어보세요." onChange={e => setAnswer2(e.target.value)} value={answer2} /></div>
                        }
                        {(meetingUser.state === 'author_request' || meetingUser.state === 'author_answer') && <div className="text">{answer2}</div>}
                    </div>
                    {meetingUser.answerReply2 !== null && meetingUser.answerReply2 !== '' &&
                        <div className="writer clear">
                            <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                <span className="name">독서길라잡이</span>
                            </div>
                            <span className="date">{dateformat(meetingUser.answerReply2Time, 'yyyy년 mm월 dd일')}</span>
                            <div className="text">{meetingUser.answerReply2}</div>
                        </div>
                    }

                    {meeting.question3 !== null && meeting.question3 !== '' &&
                        <>
                            <div className="writer clear">
                                <div className="author_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_author.png`} alt="" />
                                    <span className="name">독서길라잡이</span>
                                </div>
                                <span className="date">{dateformat(meeting.createdAt, 'yyyy년 mm월 dd일')}</span>
                                <div className="text">{meeting.question3}</div>
                            </div>
                            <div className="child clear">
                                <div className="child_profile"><img src={`${process.env.PUBLIC_URL}/static/images/meeting/talk_box_child.png`} alt="" />
                                    <span className="name">{auth.name}</span>
                                </div>
                                <span className="date">{meetingUser.answer3Time !== null && dateformat(meetingUser.answer3Time, 'yyyy년 mm월 dd일')}</span>
                                {meetingUser.state !== 'author_request' && meetingUser.state !== 'authorAnswer' &&
                                    <button type="button" className="btn _border" onClick={() => onSave('answer3')}>전송</button>
                                }
                                {meetingUser.state !== 'author_request' && meetingUser.state !== 'authorAnswer' &&
                                    <div className="text"><textarea name="answer3" className="autosize" placeholder="친구들의 생각을 적어보세요." onChange={e => setAnswer3(e.target.value)} value={answer3} /></div>
                                }
                                {(meetingUser.state === 'author_request' || meetingUser.state === 'authorAnswer') && <div className="text">{answer3}</div>}
                            </div>
                            {meetingUser.answerReply3 !== null && meetingUser.answerReply3 !== '' &&
                                <div className="writer clear">
                                    <span className="name">독서길라잡이</span>
                                    <span className="date">{dateformat(meetingUser.answerReply3Time, 'yyyy년 mm월 dd일')}</span>
                                    <div className="text">{meetingUser.answerReply3}</div>
                                </div>
                            }
                        </>
                    }

                </div>
                {meetingQuestion}
            </div>
        </div>
    );
}

MeetingTalk.defaultProps = {
    meeting: null,
    meetingUser: null
};
export default MeetingTalk;